<template>
  <div>
    <b-col>
      <b-overlay :show="loading">
        <b-card no-body>
          <b-tabs pills card>
            <b-tab
              @click="currentTab = 'TabOne'"
              title-item-class="bg-secondary rounded col m-1 px-0 text-center"
              title-link-class="text-dark"
              :title="$lang.qualificationTab1"
            >
              <b-card-text>
                <TabOne
                  @setLoading="setLoading"
                  v-if="currentTab === 'TabOne'"
                />
              </b-card-text>
            </b-tab>
            <b-tab
              @click="currentTab = 'TabTwo'"
              title-item-class="bg-secondary rounded col m-1 px-0 text-center"
              title-link-class="text-dark"
              :title="$lang.qualificationTab2"
            >
              <b-card-text>
                <TabTwo
                  @setLoading="setLoading"
                  v-if="currentTab === 'TabTwo'"
                />
              </b-card-text>
            </b-tab>
            <b-tab
              @click="currentTab = 'TabThree'"
              title-item-class="bg-secondary rounded col m-1 px-0 text-center"
              title-link-class="text-dark"
              :title="$lang.qualificationTab3"
            >
              <b-card-text>
                <TabThree
                  @setLoading="setLoading"
                  v-if="currentTab === 'TabThree'"
                />
              </b-card-text>
            </b-tab>
            <b-tab
              @click="currentTab = 'TabFour'"
              title-item-class="bg-secondary rounded col m-1 px-0 text-center"
              title-link-class="text-dark"
              :title="$lang.qualificationTab4"
            >
              <b-card-text>
                <TabFour
                  @setLoading="setLoading"
                  v-if="currentTab === 'TabFour'"
                />
              </b-card-text>
            </b-tab>
            <b-tab
              @click="currentTab = 'TabFive'"
              title-item-class="bg-secondary rounded col m-1 px-0 text-center"
              title-link-class="text-dark"
              :title="$lang.qualificationTab5"
            >
              <b-card-text>
                <TabFive
                  @setLoading="setLoading"
                  v-if="currentTab === 'TabFive'"
                />
              </b-card-text>
            </b-tab>
            <b-tab
              @click="currentTab = 'TabSix'"
              title-item-class="bg-secondary rounded col m-1 px-0 text-center"
              title-link-class="text-dark"
              :title="$lang.qualificationTab6"
            >
              <b-card-text>
                <TabSix
                  @setLoading="setLoading"
                  v-if="currentTab === 'TabSix'"
                />
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-overlay>
    </b-col>
  </div>
</template>
<script>
import TabOne from "./components/votes1/TabOne.vue";
import TabTwo from "./components/votes1/TabTwo.vue";
import TabThree from "./components/votes1/TabThree.vue";
import TabFour from "./components/votes1/TabFour.vue";
import TabFive from "./components/votes1/TabFive.vue";
import TabSix from "./components/votes1/TabSix.vue";
export default {
  components: {
    TabOne,
    TabTwo,
    TabThree,
    TabFour,
    TabFive,
    TabSix,
  },
  data() {
    return {
      currentTab: "TabOne",
      loading: false,
    };
  },
  methods: {
    setLoading(stateLoading) {
      this.loading = stateLoading;
    },
  },
};
</script>